import {createRouter, createWebHistory} from "vue-router";
import pms_landlord_login from "@/views/pms/landlord/login.vue";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import pms_landlord_store from "@/store/pms/landlord/index";
import { BASE_PATH } from "@/config/index.js";

const constants_router = [
    {
        path: `${BASE_PATH}/landlord/login`,
        name: "login",
        meta: {
            title: "PMS登录",
        },
        component: pms_landlord_login,
    },
    {
        path: "/",
        name: "index",
        meta: {
            title: "PMS管理系统",
        },
        component: pms_landlord_login,
    },
    {
        path: "/403",
        meta: {
            title: "权限不足",
        },
        component: () => import("@/views/403"),
    },
];

const router = createRouter({
    history: createWebHistory(BASE_PATH),
    routes: constants_router,
});

router.beforeEach((to, from, next) => {
    document.title = `${to.meta.title}`;
    NProgress.start();

    console.log('当前路径：', to.path);
    console.log('是否有匹配的路由：', to.matched.length > 0);
    console.log('BASE_PATH：', BASE_PATH);
    
    // 重定向包含/pms前缀的路径
    if (to.path.includes('/pms/landlord')) {
        // 移除/pms前缀，保留其他部分
        let correctedPath = to.path.replace('/pms', '');
        console.log('重定向路径：', correctedPath);
        next({
            path: correctedPath,
            query: to.query, // 传递原始的query参数
            replace: true,
        });
        return;
    }
    
    // pms房东端
    if (Number(to.fullPath.indexOf(`${BASE_PATH}/landlord`)) > 0) {
        let token = sessionStorage.getItem("landlordInfo")
            ? JSON.parse(sessionStorage.getItem("landlordInfo")).token
            : false;
        if (token) {
            // 判断路由是否有数据
            if (pms_landlord_store.getters.routersLength == 0) {
                console.log('加载动态路由');
                pms_landlord_store
                    .dispatch("loadMenus")
                    .then(() => {
                        // 动态路由加载完成后，重新导航到当前路由
                        console.log('动态路由加载完成，重新导航到：', to.path);
                        next({
                            ...to,
                            replace: true,
                        });
                    })
                    .catch(() => {
                        next("/403");
                    });
            } else {
                next();
                NProgress.done();
            }
        } else {
            if (to.path === `${BASE_PATH}/landlord/login`) {
                next();
                NProgress.done();
            } else {
                next({
                    path: `${BASE_PATH}/landlord/login`,
                    replace: true,
                });
            }
        }
    } else {
        if (to.path === "/403") {
            next();
            NProgress.done();
        } else if (to.matched.length === 0) {
            // 如果没有匹配到路由，先检查是否需要加载动态路由
            let token = sessionStorage.getItem("landlordInfo")
                ? JSON.parse(sessionStorage.getItem("landlordInfo")).token
                : false;
            if (token && pms_landlord_store.getters.routersLength == 0) {
                // 有token但没有加载动态路由，尝试加载
                console.log('没有匹配到路由，但有token，尝试加载动态路由');
                pms_landlord_store
                    .dispatch("loadMenus")
                    .then(() => {
                        next({
                            ...to,
                            replace: true,
                        });
                    })
                    .catch(() => {
                        next("/403");
                    });
            } else {
                // 没有token或已经加载了动态路由，还是没有匹配到，跳转到登录或404
                if (token) {
                    // 有token但没有匹配到路由，说明路径确实不存在，跳转到404
                    next({ path: "/404" });
                } else {
                    // 没有token，跳转到登录页
                    next({ path: `${BASE_PATH}/landlord/login` });
                }
            }
        } else {
            next();
            NProgress.done();
        }
    }
});

export default router;
